import {
  EmptySectionCard,
  FAIconName,
  FireflyButton,
  InquiryDetailSectionHeader,
  ProviderAvatarBlockCard,
  ProviderAvatarBlockCardProps,
  SkeletonLoader,
} from '@equip.health/ui';

import { Section } from '~/components/common/Section';

export interface AdmissionTeamProps {
  id: string;
  isLoading: boolean;
  members: ProviderAvatarBlockCardProps[];
  onEdit: () => void;
}

export const AdmissionTeam = ({
  id,
  isLoading,
  members,
  onEdit,
}: AdmissionTeamProps) => {
  const TOPLEVEL_ID = `${id}__admissions-team`;

  const admissionTeamCards =
    members.length > 0 ? (
      members.map((m) => {
        return (
          <ProviderAvatarBlockCard
            avatarUrl={m.avatarUrl}
            credentials={m.credentials}
            deactivatedDate={m.deactivatedDate}
            displayName={m.displayName}
            id={m.id}
            key={m.id}
            legalName={m.legalName}
            oooDate={m.oooDate}
            otherPronoun={m.otherPronoun}
            pronouns={m.pronouns}
            providerTypeName={m.providerTypeName}
            shouldShowCredentials
            shouldShowDeactivatedDate
            shouldShowOOOIcon
            shouldShowPronouns
            shouldShowProviderType
            size="medium"
          />
        );
      })
    ) : (
      <EmptySectionCard
        caption="No team members have been added"
        id={TOPLEVEL_ID}
      />
    );

  return (
    <Section id={TOPLEVEL_ID}>
      <InquiryDetailSectionHeader
        id={`${TOPLEVEL_ID}-header`}
        title="Admissions team"
      >
        <FireflyButton
          id={`${TOPLEVEL_ID}-edit-button`}
          isDisabled={isLoading}
          leftIcon={FAIconName.penRegular}
          onClick={onEdit}
          size="small"
          variant="secondary"
        >
          Edit
        </FireflyButton>
      </InquiryDetailSectionHeader>
      <SkeletonLoader id={TOPLEVEL_ID} isLoaded={!isLoading}>
        <Section id={`${TOPLEVEL_ID}-children`}>{admissionTeamCards}</Section>
      </SkeletonLoader>
    </Section>
  );
};
